var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 18.125L17.625 6.875M8.25 11.25V8.75M8.25 8.75V6.25M8.25 8.75H5.75M8.25 8.75H10.75M13.25 16.875H18.25M4.7027 22.5H19.2973C20.79 22.5 22 21.29 22 19.7973V5.2027C22 3.71004 20.79 2.5 19.2973 2.5H4.7027C3.21004 2.5 2 3.71004 2 5.2027V19.7973C2 21.29 3.21004 22.5 4.7027 22.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulator);
export default __webpack_public_path__ + "static/media/simulator.8664efb33ebed364a9ccec0454ee6450.svg";
export { ForwardRef as ReactComponent };